import { useSettings } from "@utilities/context/settings";
import clsx from "clsx";
import BrandIconThink from "../../public/image/svg/think-logo.svg";
import styles from "./C200_1_BrandIconTitle.module.scss";

export const BrandIconTitle = (props: { isH2?: boolean }) => {
  const { isH2 } = props;
  const { siteSettings } = useSettings();

  const classNames = clsx(styles["section-title"], styles["visually-hidden"]);

  return (
    <div
      className={clsx(
        "component",
        styles["brand-title"],
        styles["brand-title--icon"]
      )}
    >
      <div className={clsx("wrapper", styles.wrapper)}>
        {isH2 ? (
          <h2 className={classNames}>{siteSettings?.brandIconTitleText}</h2>
        ) : (
          <h1 className={classNames}>{siteSettings?.brandIconTitleText}</h1>
        )}
        <div className="image-wrapper">
          <BrandIconThink aria-hidden className="w-[74px] md:w-[98px]" />
        </div>
      </div>
    </div>
  );
};

export default BrandIconTitle;
